import React from "react";
import { Link } from "react-router-dom";
import { backgroundImg } from "src/assets/assetsExport";
import { AREA_GUIDES } from "src/data/areaGuides";

const AreaGuideTeaser: React.FC = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[#E5E5E5] py-16 md:py-20">
      <img
        src={backgroundImg.london}
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center opacity-40 grayscale contrast-125 z-0"
        draggable={false}
        aria-hidden
      />
      <div className="absolute inset-0 bg-black/25 z-0" />

      <div className="relative z-10 max-w-[1200px] mx-auto px-[5%]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10">
          <div>
            <span className="text-xs uppercase tracking-wider text-white/80 block mb-2">
              Locations
            </span>
            <h2 className="page-section-heading uppercase text-white">
              Area Guides
            </h2>
            <div className="w-16 h-1.5 bg-brand-yellow mt-2" />
          </div>
          <Link
            to="/guides/areas"
            className="font-teko text-sm uppercase text-white border border-solid border-white px-5 py-2 hover:bg-white hover:text-text-obsidian transition-colors shrink-0"
          >
            View all guides
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {AREA_GUIDES.map((guide) => (
            <Link
              key={guide.slug}
              to={`/guides/areas/${guide.slug}`}
              className="group bg-white/95 backdrop-blur-sm p-5 border border-solid border-[rgba(0,0,0,0.06)] transition-all duration-300 hover:border-brand-yellow hover:-translate-y-0.5"
            >
              <h3 className="font-teko text-xl text-text-obsidian mb-1 group-hover:text-brand-gold transition-colors">
                {guide.title}
              </h3>
              <p className="font-manrope text-xs text-text-slate leading-relaxed">
                {guide.tagline}
              </p>
              <span className="font-teko text-xs uppercase text-brand-gold mt-3 inline-block group-hover:text-text-obsidian transition-colors">
                Explore →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreaGuideTeaser;
